/**
 * Helpers for multi-skill values, which arrive from the API as a
 * comma-separated list of skill codes with no spaces (e.g. "RN,LPN").
 */
export const splitSkillCodes = (raw?: string | null): string[] =>
    (raw ?? '')
        .split(',')
        .map((code) => code.trim())
        .filter(Boolean);

/** "RN,LPN" -> "RN, LPN" */
export const formatSkillCodes = (raw?: string | null): string =>
    splitSkillCodes(raw).join(', ');

/** "RN,LPN" -> "Registered Nurse, Licensed Practical Nurse" (falls back to the code when no description exists). */
export const formatSkillDescriptions = (
    raw: string | null | undefined,
    labelByCd: Record<string, string>
): string =>
    splitSkillCodes(raw)
        .map((code) => labelByCd[code] || code)
        .join(', ');
